import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackActivity } from '../utils/activityTracker';

const inferTabName = (path) => {
    if (!path || path === '/') return "Home";
    // Get the first meaningful segment
    const segment = path.split('/').filter(p => p)[0] || "Home";
    // Capitalize and return - this handles any new path generically
    return segment.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

const ActivityTracker = () => {
    const location = useLocation();
    const prevPath = useRef(location.pathname);

    // Track Page Views / Tab Changes Generically
    useEffect(() => {
        const tabName = inferTabName(location.pathname);
        if (location.pathname !== prevPath.current) {
            trackActivity({
                tab_name: tabName,
                action: "PAGE_VIEW",
                metadata: {
                    full_path: location.pathname,
                    search: location.search,
                    referrer: document.referrer
                }
            });
            prevPath.current = location.pathname;
        } else {
            // Initial load or refresh
            trackActivity({
                tab_name: tabName,
                action: "APP_INIT",
                metadata: {
                    full_path: location.pathname,
                    viewport: `${window.innerWidth}x${window.innerHeight}`
                }
            });
        }
    }, [location.pathname, location.search]);

    // Track Tab Visibility (Background/Foreground)
    useEffect(() => {
        const handleVisibilityChange = () => {
            const currentTab = inferTabName(window.location.pathname);
            trackActivity({
                tab_name: currentTab,
                action: document.hidden ? "APP_HIDDEN" : "APP_VISIBLE",
                metadata: {
                    timestamp: new Date().toISOString()
                }
            });
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return null;
};

export default ActivityTracker;
